import { Input, InputProps } from "antd";
import styles from "./styles/base-input.module.scss";
import clsx from "clsx";

interface Props extends InputProps {

}

const BaseInput = ({ className, ...rest }: Props) => {
    return (
        <Input className={(clsx(styles.input, className))}  {...rest} />
    );
};

export default BaseInput;

